import { render, staticRenderFns } from "./CSVGrid.vue?vue&type=template&id=04f4b8f3&scoped=true&lang=pug"
import script from "./CSVGrid.vue?vue&type=script&lang=js"
export * from "./CSVGrid.vue?vue&type=script&lang=js"
import style0 from "./CSVGrid.vue?vue&type=style&index=0&id=04f4b8f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f4b8f3",
  null
  
)

export default component.exports